import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_ENTERPRISE_ADMIN, API_PROJECT_TYPE } from '../util/api.endpoints';

@Injectable({
  providedIn: 'root'
})
export class ProjetTypeService {

  constructor(private http: HttpClient) { }

  private getAuthToken(): string | null {
    return localStorage.getItem('jwtToken');
  }

  private getAuthHeaders(): HttpHeaders {
    const token = this.getAuthToken();
    return new HttpHeaders({
      'Authorization': token ? `Bearer ${token}` : '',
      'Content-Type': 'application/json'
    });
  }

  submitProjectTypeWithSection(data: any): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.post(API_PROJECT_TYPE, data, { headers });
  }

  submitProjectTypeWithOutSection(data: any): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.post(API_PROJECT_TYPE, data, { headers });
  }

  getProjectTypes(params): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.get<any>(API_PROJECT_TYPE, { params });
  }

  getProjectTypeById(id: string): Observable<any> {
    const url = `${API_PROJECT_TYPE}/${id}`;
    return this.http.get<any>(url);
  }

  updateProjectType(id: string, data: any): Observable<any> {
    const headers = this.getAuthHeaders();
    const url = `${API_PROJECT_TYPE}/${id}`;
    return this.http.put(url, data, { headers });
  }

  deleteProjectType(id: string): Observable<any> {
    const url = `${API_PROJECT_TYPE}/${id}`;
    const headers = this.getAuthHeaders();
    return this.http.delete<any>(url, { headers });
  }
}